export const OPEN_MODAL_FORM_GROUPER = "OPEN_MODAL_FORM_GROUPER";
export const CLOSE_MODAL_FORM_GROUPER = "CLOSE_MODAL_FORM_GROUPER";
export const SAVE_NAME_GROUPER_GROUPER = "SAVE_NAME_GROUPER_GROUPER";
